var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 20.4167H14.5833V16.9167H18.0833V15.75H14.5833V12.25H13.4167V15.75H9.91667V16.9167H13.4167V20.4167ZM5.83333 24.5V3.5H16.9167L22.1667 8.75V24.5H5.83333ZM16.3333 9.33333H21L16.3333 4.66667V9.33333Z",
    fill: "#1D2951",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddicon);
export default __webpack_public_path__ + "static/media/addicon.1e71ac7aac6a1a94fbf5be5e1cd8e892.svg";
export { ForwardRef as ReactComponent };